module.exports = __webpack_public_path__ + "img/bg_homeTop.315258b0.png";